import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountOrNetworkAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/siders/{siderId}").GET();

export type Sider = typeof endpoint.types.Res;

export async function getSider(params: typeof endpoint.types.P, query: typeof endpoint.types.Q) {
    const call = createCall(endpoint, (r) => fetch(withAccountOrNetworkAuthHeaders(r)));

    return await call({
        params,
        query,
    });
}
